module.exports = __webpack_public_path__ + "img/nu.nue4a214a.svg";